import PageHeader from '../molecules/PageHeader';
import { Link } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from '@mui/x-data-grid';

const NominalRoleLayout = ({ levelSelection, dataRow, columns, loading }) => {
  const backLink = (
    <>
      <ArrowBackIosIcon fontSize='small' />
      <Link to={`/manage/classes/${levelSelection}`}>Back To Classes</Link>
    </>
  );

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarExport
          csvOptions={{
            fileName: 'NominalRoll-Level-' + levelSelection,
            utf8WithBom: true,
          }}
          printOptions={{
            disableToolbarButton: true,
          }}
        />
      </GridToolbarContainer>
    );
  }

  return (
    <div>
      <PageHeader backLink={backLink} testid='nominal-role-title'>
        Nominal Roll for Level {levelSelection}
      </PageHeader>

      <DataGrid
        autoHeight
        loading={loading}
        slots={{
          toolbar: CustomToolbar,
        }}
        rows={dataRow}
        columns={columns}
        initialState={{
          pagination: { paginationModel: { pageSize: 25 } },
        }}
        pageSizeOptions={[25, 50, 100]}
        disableRowSelectionOnClick
      />
    </div>
  );
};

export default NominalRoleLayout;
